export default (props = {}) => <svg width="32" height="32" viewBox="0 0 32 32" fill="currentColor" xmlns="http://www.w3.org/2000/svg"{...props}>
<g id="tips/close_mark">
<path id="Union" d="M26 8.33298L18.333 16L26 23.667L23.667 26L16 18.333L8.33298 26L6 23.667L13.667 16L6 8.33298L8.33298 6L16 13.667L23.667 6L26 8.33298Z"/>
</g>
</svg>
